import React, { useContext, useEffect } from 'react';
import { ActionStyle } from '../../action/action-constants.js';
import { HeadingContext } from '../../heading/components/heading-context/heading-context.js';
import { Link } from '../../link/link.js';
const EDIT_EXPRESSION = 'tws.form.edit';
function FormEditAction(props) {
    const context = useContext(HeadingContext);
    useEffect(() => {
        if (!context) {
            return;
        }
        const popAction = context.addOrUpdateAction({
            enabled: true,
            icon: '/static/assets/components/DLS_Edit.svg',
            id: 'form-external-edit-action',
            inlineOnMobile: true,
            onClick: props.onClick,
            style: ActionStyle.TEXT,
            tabIndex: props.tabIndex,
            text: EDIT_EXPRESSION,
        });
        return () => {
            popAction();
        };
    }, []);
    if (context) {
        return null;
    }
    return (React.createElement(Link, { className: "c-form__edit", onClick: props.onClick, value: EDIT_EXPRESSION }));
}
export { FormEditAction, };
//# sourceMappingURL=form-edit-action.js.map